import { SplitFactoryProvider } from '@splitsoftware/splitio-react'
import type { JSX, ReactNode } from 'react'

/**
 * Public pages have no organization identity for feature targeting.
 * Use useSplitEnabled: it resolves with the default value when no client exists.
 * useSplit and useSplits remain unready without feature attributes. Public pages
 * must not wait on their isReady state.
 */
export function AnonymousFeaturesWrapper({
  children,
}: {
  children: ReactNode
}): JSX.Element {
  return <SplitFactoryProvider>{children}</SplitFactoryProvider>
}
